<template>
    <button class="btn btn-green w-100" data-bs-toggle="modal" data-bs-target="#post-in-published">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="me-1 icon-tabler icons-tabler-outline icon-tabler-bulb">
      <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
      <path d="M3 12h1m8 -9v1m8 8h1m-15.4 -6.4l.7 .7m12.1 -.7l-.7 .7"/>
      <path d="M9 16a5 5 0 1 1 6 0a3.5 3.5 0 0 0 -1 3a2 2 0 0 1 -4 0a3.5 3.5 0 0 0 -1 -3"/>
      <path d="M9.7 17l4.6 0"/>
    </svg>
    Включить
  </button>

  <div class="modal modal-blur fade" id="post-in-published" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Включение поста</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" ref="closeModal"></button>
        </div>
        <div class="modal-body">
          <div class="mb-4">
          <label class="row">
            <span class="col">
              <span class="title">Обновить дату публикации?</span>
            </span>
            <span class="col-auto">
              <label class="form-check form-check-single form-switch">
                <input class="form-check-input" type="checkbox" v-model="fields.update_published_at">
              </label>
            </span>
          </label>
          </div>
          <button class="btn btn-red w-100" @click="onClick">
            <span class="spinner-border spinner-border-sm me-2" v-show="isLoad()"></span>
            Включить пост
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {defineComponent, ref, reactive, watch} from "vue"
import Api from "./services/Api"
import Notify from "@/services/Notify"

export default defineComponent({
  name: "InPublished",
  props: {
    payload: {
      type: Object,
      required: true,
    },
  },
  setup(props, {emit}) {
    let load = ref(false)
    let closeModal = ref(null)
    let fields = reactive(getFields())

    watch(() => props.payload, () => {
      updateFields(props.payload)
    }, {
      immediate: true
    })

    async function updateFields(query) {
      fields.post_id = query.post_id
    }

    function getFields() {
      return {
        post_id: null,
        update_published_at: true,
      }
    }

    function onClick() {
      startLoad()

      Api.inPublished(fields.post_id, fields.update_published_at).then(() => {
        emit('onChange', true)
      }).then(() => {
        closeModalWindow()
        Notify.success("Поставлена задача на включение поста")
      }).catch(() => {
        emit('onChange', false)
      }).finally(() => {
        stopLoad()
      })
    }

    function isLoad() {
      return load.value === true
    }

    function startLoad() {
      load.value = true
    }

    function stopLoad() {
      load.value = false
    }

    function closeModalWindow() {
      closeModal.value.click()
    }

    return {
      onClick,
      isLoad,
      closeModal,
      fields,
    }
  },
})
</script>
